/*
 * Jira Ticket:
 * Created Date: Thu, 4th Jun 2020, 09:44:14 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  FunctionField,
  List,
  Datagrid,
  TextField,
  NumberField,
  usePermissions,
  Title,
} from 'react-admin';
import ListActions from './actions';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';
import { formatMoneyPlan } from 'utils';
import { PostPagination } from '../../Components/CustomPagination/pagination';

const SubscriptionCostField = ({ record, source, ...props }) => {
  if (record && record[source]) {
    const plan = record[source].cost;
    return formatMoneyPlan(plan);
  } else if (record.isFreeTier) {
    return 'Free';
  }
  return 'N/A';
};

const SubscriptionTierList = props => {
  const { permissions } = usePermissions();
  return isSuperAdmin(permissions) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        bulkActionButtons={false}
        perPage={25}
        pagination={<PostPagination />}
        actions={<ListActions />} // we request the capabilities in here to prefill the create form
        {...props}
      >
        <Datagrid rowClick="edit">
          <TextField
            source="name"
            label="resources.SubscriptionTier.fields.name"
            sortable={false}
          />
          <FunctionField
            label="resources.SubscriptionTier.fields.monthlyCost"
            render={record => (
              <SubscriptionCostField record={record} source="monthlyPlan" />
            )}
          />
          <NumberField
            source="statistics.monthlySubscribers"
            label="resources.SubscriptionTier.fields.monthlySubscribers"
            sortable={false}
          />
          <NumberField
            source="statistics.freeSubscribers"
            label="resources.SubscriptionTier.fields.freeSubscribers"
            sortable={false}
          />
          <FunctionField
            label="resources.SubscriptionTier.fields.annualCost"
            render={record => (
              <SubscriptionCostField record={record} source="annualPlan" />
            )}
          />
          <NumberField
            source="statistics.annualSubscribers"
            label="resources.SubscriptionTier.fields.annualSubscribers"
            sortable={false}
          />
        </Datagrid>
      </List>
    </>
  ) : (
    <AccessDenied />
  );
};

export default SubscriptionTierList;
